module.exports = __webpack_public_path__ + "static/media/summer@2x.4646bfc0.png";